var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jump-to-nav",
    {
      staticClass: "laptop:position-sticky-top laptop:padding-top-2xl",
      attrs: { title: "On This Page" },
    },
    [
      _c(
        "list",
        [
          _c("list-item", { attrs: { hash: "#account" } }, [
            _vm._v("Account Terms"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#cancelation" } }, [
            _vm._v("Cancelation & Termination"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#modifications" } }, [
            _vm._v("Modifications to the Service"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#copyright" } }, [
            _vm._v("Copyright and Content Ownership"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#general" } }, [
            _vm._v("General Conditions"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }